<template>
  <div class="messages">
    <div class="messages__body">
      <a v-if="getMessages.length">
        <template v-for="(messagesItem, idx) in getMessages">
          <div class="messages__item"
               :key="idx"
               v-if="getParticipant(messagesItem)"
               :class="{active: messagesItem.conversation_id === active}"
               @click="selectConversation(messagesItem)"
          >
            <div class="messages__item-logo">
              <img :src="getParticipant(messagesItem).avatar">
            </div>
            <div class="messages__item-top">
              <div class="messages__item-top-user">
                <div>
                  <div class="messages__item-fullname">
                    {{ getParticipant(messagesItem).name ? getParticipant(messagesItem).name : 'DELETED' }}
                    {{ getParticipant(messagesItem).surname ? getParticipant(messagesItem).surname : '' }}
                  </div>
                </div>
                <div>
                  <div class="messages__item-date" v-if="messagesItem.conversation.last_message">
                    {{ dateFunc(messagesItem.conversation.last_message.created_at) }}
                  </div>
                </div>
              </div>
              <div class="messages__item-body" v-if="messagesItem.conversation.last_message">
                <p>{{ messagesItem.conversation.last_message.body }}</p>
              </div>
            </div>
          </div>
        </template>
      </a>
      <div v-else>
        <h4 class="no-content">Список пуст</h4>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex"

export default {
  name: 'Messages',
  props: {
    messages: Array,
    search: String
  },
  data: () => ({
    active: null
  }),
  computed: {
    ...mapGetters(['getUser']),
    getMessages() {
      if (this.search === '') {
        return this.messages
      }

      return this.messages.filter((item) => {
        return this.getParticipant(item).name?.indexOf(this.search) >= 0
      })
    },
  },
  methods: {
    selectConversation(messagesItem) {
      const participant = this.getParticipant(messagesItem)
      const fullname = `${participant.name} ${participant.surname}`
      this.$emit('conversation', {id: messagesItem.conversation_id, fullname, participant})
      this.active = messagesItem.conversation_id
    },
    dateFunc(date) {
      let duration = this.$moment.duration(this.$moment().diff(date))
      if (duration.asHours() > 4) {
        return this.$moment(date).calendar()
      } else if (duration.asMinutes() < 1) {
        return 'только что'
      } else {
        return this.$moment(date).fromNow()
      }
    },
    getParticipant(messagesItem) {
      return messagesItem.conversation.participants.filter((item) => {
        return item.messageable_id != this.getUser.id
      })[0].messageable
    }
  }
}
</script>
<style scoped lang="scss">
.messages {
  background-color: #fff;
  padding: 0 0;
}

.messages__item {
  padding: 10px 15px;
  border-bottom: 1px solid #E5E5E5;
  display: flex;

  &.active {
    color: #383838;
    background-color: #DBBFA7;
    border-right: none;

    &:hover {
      opacity: 1;
    }
  }

  &-top {
    width: calc(100% - 60px);

    &-user {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  &-fullname {
    font-weight: 600;
    font-size: 16px;
    color: #383838;
  }

  &-date {
    line-height: 24px;
    font-size: 14px;
    color: #808080;
  }

  &-logo {
    overflow: hidden;
    border: 1px solid #DBBFA7;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;

    img {
      width: 50px;
      height: 50px;
    }
  }

  &-body {
    font-size: 14px;
    line-height: 1.71;
    color: #383838;

    p {
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.no-content {
  padding: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center
}

@media screen and (max-width: 480px) {
  .messages__item-date {
    display: none;
  }
}
</style>
